import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'dexio-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.css'
})
export class CheckboxComponent {
  @Input() id?: string = 'dexio-checkbox-' + Math.floor(Math.random() * 99999);
  @Input() label?: any;
  @Input() model: any;
  @Output() modelChange: EventEmitter<any> = new EventEmitter();
  @Input() trueValue?: any = true;
  @Input() falseValue?: any = false;


  changeCheckboxValue($event: any) {
    var value = ($event.target?.checked) ? this.trueValue : this.falseValue;
    this.modelChange.emit(value);
  }
}
